<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-12">
                <div style="display: flex; align-items: center;justify-content: space-between;" class="py-2">
                    <h4 class="custom-font"> Document Upload Request</h4>
                </div>
            </div>
        </div>
        <div class="card row ">
            <div class=" col-lg-12 col-md-12 col-12 p-4">
                <div>
                    <h6 style=" color: red;"> 1) File size should be less then 1 MB.</h6>
                    <h6 style="color: red;"> 2) You can upload jpg, jpeg, png or pdf file only.</h6>
                </div>
                <form #documentUpload="ngForm" (ngSubmit)="onSubmit()" class="pb-3">
                    <div class="row">
                       
                        <div class="col-lg-4 col-md-12 col-12">
                            <div class="form-group">
                                <label class="form-label"><b>Section</b><span class="text-danger">
                                        *</span></label>
                                <select class="form-control" #SectionID="ngModel" ngModel name="SectionID"
                                    name="SectionID" (change)="fillCourse()" required>
                                    <option *ngFor="let s of sections" [value]="s.value"
                                        [selected]="SectionID == s.value">
                                        {{ s.text }}
                                    </option>
                                </select>
                                <span *ngIf="submitted">
                                    <p *ngIf="this.documentUploadForm.controls['SectionID'].value == '0'"
                                        class="error_message" style="color: red">
                                        Section is required
                                    </p>
                                </span>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-12 col-12">
                            <div class="form-group">
                                <label class="form-label"><b>Course</b><span class="text-danger">
                                        *</span></label>
                                <select class="form-control" #CourseID="ngModel" ngModel name="CourseID"
                                    id="CourseID" required>
                                    <option *ngFor="let c of courses" [value]="c.value"
                                        [selected]="CourseID == c.value">
                                        {{ c.text }}
                                    </option>
                                </select>
                                <span *ngIf="submitted">
                                    <p *ngIf="this.documentUploadForm.controls['CourseID'].value == '0'"
                                        class="error_message" style="color: red">
                                        Course is required
                                    </p>
                                </span>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-12 col-12">
                            <div class="form-group">
                                <label class="form-label"><b>Medium</b><span class="text-danger">
                                        *</span></label>
                                <select class="form-control" #MediumID="ngModel" ngModel name="MediumID"
                                    name="MediumID" required>
                                    <option *ngFor="let m of mediums" [value]="m.value"
                                        [selected]="MediumID == m.value">
                                        {{ m.text }}
                                    </option>
                                </select>
                                <span *ngIf="submitted">
                                    <p *ngIf="this.documentUploadForm.controls['MediumID'].value == '0'"
                                        class="error_message" style="color: red">
                                        Medium is required
                                    </p>
                                </span>
                            </div>
                        </div>
                      
                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-md-12 col-12">
                            <div class="form-group">
                                <label class="form-label "><b>Academic Year</b><span class="text-danger">
                                        *</span></label>
                                <select class="form-control" #AcademicYearID="ngModel" ngModel id="AcademicYearID"
                                    name="AcademicYearID">
                                    <option *ngFor="let y of years" [value]="y.value"
                                        [selected]="AcademicYearID == y.value">
                                        {{ y.text }}
                                    </option>
                                </select>
                                <span *ngIf="submitted">
                                    <p *ngIf="this.documentUploadForm.controls['AcademicYearID'].value == '0'"
                                        class="error_message" style="color: red">
                                        Academic Year is required
                                    </p>
                                </span>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-12 col-12">
                            <div class="form-group">
                                <label class="form-label"><b>Document</b><span class="text-danger">
                                        *</span></label>
                                <select class="form-control" #DocumentID="ngModel" ngModel name="DocumentID"
                                    (change)="displayAmout()" name="DocumentID" required>
                                    <option *ngFor="let d of documentTypes" [value]="d.value"
                                        [selected]="DocumentID == d.value">
                                        {{ d.text }}
                                    </option>
                                </select>
                                <span *ngIf="submitted">
                                    <p *ngIf="this.documentUploadForm.controls['DocumentID'].value == '0'"
                                        class="error_message" style="color: red">
                                        Document is required
                                    </p>
                                </span>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-12 col-12 mb-0">
                            <div class="form-group">
                                <label class="form-label"><b>File</b><span class="text-danger">
                                        *</span></label>
                                <input type="file" id="input-file-max-fs" id="customFile" name="customFile"
                                    (change)="uploadImage($event)" class="form-control" data-max-file-size="2M" />
                                <span *ngIf="submitted">
                                    <p *ngIf="base64file == null" class="error_message" style="color: red">
                                        File is required
                                    </p>
                                </span>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-12 col-12 mb-0" *ngIf="visibleAmout">
                            <div class="form-group">
                                <label class="form-label"><b>Amount</b><span class="text-danger">
                                        *</span></label>
                                <input class="form-control" type="text" name="Amount" placeholder="Enter amount"
                                    maxlength="15" autocomplete="off" (keypress)="onlyDouble($event)"
                                    #FeesIncrease="ngModel" ngModel required />
                                <span *ngIf="submitted">
                                    <p *ngIf="this.documentUploadForm.controls['Amount'].value == ''"
                                        class="error_message" style="color: red">
                                        Amount is required
                                    </p>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3" style="margin-top: 27px;">
                            <button class="btn btn-success" type="submit" style="margin: 5px;">Submit</button>
                            <button class="btn btn-danger" type="button" style="margin: 5px;"
                                (click)="resetForm()">Clear</button>

                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="card row " >
            <div class=" col-lg-12 col-md-12 col-12 p-4">
                <div class="row">
                    <div class="col-md-11">
                        <div class="py-3">
                            <input type="text" id="searchtext" class="form-control bg-white border-0 small"
                                placeholder="Search for..." [(ngModel)]="searchtext" aria-label="Search"
                                aria-describedby="basic-addon2" />
                        </div>
                    </div>
                    <div class="col-md-1">
                        <div class="py-3">
                        <button class="btn btn-success" (click)="SchoolDocumentList(1);"
                            style="margin: 5px;">Search</button>
                            </div>
                    </div>
                </div>
                <div class="table-responsive">
                    <table id="example" class="table table-striped table-bordered" style="width:100%">
                        <thead>
                            <tr>
                                <th class="pointer" scope="col" (click)="sortBy('SrNo')">Sr. no.</th>
                                <th class="pointer" scope="col" (click)="sortBy('StandardName')">Course name</th>
                                <th class="pointer" scope="col" (click)="sortBy('InstituteType')">Institute type</th>
                                <th class="pointer" scope="col" (click)="sortBy('Section')">Section</th>
                                <th class="pointer" scope="col" (click)="sortBy('MediumName')">Medium name</th>
                                <th class="pointer" scope="col" (click)="sortBy('AcademicYear')">Academic year</th>
                                <th class="pointer" scope="col" (click)="sortBy('DocumentName')"> Document name</th>
                                <th class="pointer" scope="col" (click)="sortBy('Amount')"> Amount</th>
                                <th class="pointer" scope="col">Preview</th>
                                <th class="pointer" scope="col" (click)="sortBy('Status')">Status</th>
                                <th class="pointer" scope="col" (click)="sortBy('Remark')">Admin remark</th>
                                <th class="pointer" scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="schoolDocumentList != undefined && schoolDocumentList.length > 0">
                            <tr
                                *ngFor="let r of schoolDocumentList | paginate: { itemsPerPage: pageLimit,currentPage: p ,totalItems: totalDocument};let i = index">
                                <td>{{r.SrNo}}</td>
                                <td>
                                    <p>{{r.StandardName}}</p>
                                </td>
                                <td>
                                    <p>{{r.InstituteType}}</p>
                                </td>
                                <td>
                                    <p>{{r.Section}}</p>
                                </td>
                                <td>
                                    <p>{{r.MediumName}}</p>
                                </td>
                                <td>
                                    <p>{{r.AcademicYear}}</p>
                                </td>
                                <td>
                                    <p>{{r.DocumentName}}</p>
                                </td>
                                <td>
                                    <p>{{r.Amount}}</p>
                                </td>
                                <td>
                                    <p>
                                        <a href="{{r.FilePath}}" target="_blank">
                                            <img src="{{r.ViewURL}}" class="img-fluid no-img "
                                                style="width: 110px;height: 110px;" id="preview_{{i}}" />
                                        </a>
                                    </p>
                                </td>
                                <td>
                                    <p *ngIf="r.Status == 0" style="color: black;font-weight: bold;">Pending</p>
                                    <p *ngIf="r.Status == 1" style="color: green;font-weight: bold;">Approved</p>
                                    <p *ngIf="r.Status == 2" style="color: red;font-weight: bold;">Rejected</p>
                                </td>
                                <td>
                                    <p>{{r.Remark}}</p>
                                </td>
                                <td>
                                    <button type="button" class="btn btn-danger rmb_10" *ngIf="r.Status != 1"
                                        (click)="deleteDocument(r.HashCode,r.FilePath)">Delete</button>
                                </td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="schoolDocumentList == undefined || schoolDocumentList.length == 0">
                            <tr>
                                <td colspan="12" style="text-align: center;">
                                    No record found
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="card-footer pb-0 pt-3" align="right" *ngIf="schoolDocumentList != undefined && schoolDocumentList.length > 0">
                        <pagination-controls (pageChange)="SchoolDocumentList($event)" responsive="true"
                                maxSize="{{totalPages}}"></pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-login custom-footer">
        <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
        <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
    </div>
    <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white;">Please Wait.</p>
    </ngx-spinner>
</div>